import React, { PureComponent } from 'react';
import { Radio, Row, Col } from 'antd';
import AwsPolicy from './AwsPolicy';
import SecurityAndAuditPolicy from './SecurityAndAuditPolicy';
class PolicySelector extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.policy,
    };
  }
  setSelected = event => {
    const { target } = event;
    const { value } = target;
  };

  SecurityAudit = value => {
    this.setState({
      value: 'SecurityAudit',
    });
    this.props.selectedpolicy('SecurityAudit');
  };
  render() {
    return (
      <div style={{ marginTop: -13 }}>
        <Row type="flex">
          <Col>
            <Radio.Group buttonStyle="solid" defaultValue={this.props.policy}></Radio.Group>
          </Col>
        </Row>
        {this.state.value === 'SecurityAudit' ? <SecurityAndAuditPolicy /> : <AwsPolicy />}
      </div>
    );
  }
}
export default PolicySelector;
